import type { Editor } from '@/modules/Editor/editor'
import { DicomView } from '@/modules/Editor/views/dicomView'

export const toggleReferenceLines = (editor: Editor): void =>
  editor.viewsList.forEach((view) => view instanceof DicomView && view.toggleReferenceLines())
